var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12846 2.05026C9.28644 1.89228 9.28625 1.62617 9.12201 1.46193L8.53827 0.878195C8.36701 0.706928 8.11063 0.711065 7.94995 0.871746L4.99998 3.82171L2.05001 0.871746C1.89203 0.713766 1.62593 0.713952 1.46169 0.878195L0.877951 1.46193C0.706684 1.6332 0.71082 1.88958 0.871502 2.05026L3.82147 5.00022L0.871502 7.95019C0.713522 8.10817 0.713708 8.37428 0.877951 8.53852L1.46169 9.12225C1.63295 9.29352 1.88933 9.28938 2.05001 9.1287L4.99998 6.17874L7.94995 9.1287C8.10793 9.28668 8.37403 9.2865 8.53827 9.12225L9.12201 8.53852C9.29328 8.36725 9.28914 8.11087 9.12846 7.95019L6.17849 5.00022L9.12846 2.05026Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7179eb5cda0388f222c85480342fa63e.svg";
export { ForwardRef as ReactComponent };